<template>
  <v-container class="mb-12">
    <div class="page-header">
      <div class="left">
        <h2>{{ $t("message.permissions.team") }}</h2>
        <SelectedCompany class="mt-2" />
      </div>
      <div class="right">
        <ui-button
          icon="icon-plus"
          color="primary"
          @click="addMember"
          v-if="hasMembers && canManageTeam"
        >
          {{ $t("message.permissions.addNewUser") }}
        </ui-button>
      </div>
    </div>
    <v-card class="card-rounded">
      <v-card-text>
        <CompanyMembersList
          ref="membersList"
          :add-handler="addMember"
          @count="hasMembers = $event > 0"
        ></CompanyMembersList>
      </v-card-text>
    </v-card>

    <MemberDialog v-if="memberDialog" :loading="loading" />
    <FacilitiesDialog v-if="facilitiesDialog" />
    <PermissionsDialog v-if="permissionsDialog" />
    <PermissionsGrantedDialog
      v-if="permissionsGrantedDialog"
      @confirmed="$refs.membersList.refresh()"
    />
  </v-container>
</template>

<script>
import CompanyMembersList from "@/components/Permissions/CompanyMembersList";
import MemberDialog from "@/components/Permissions/MemberDialog";
import { mapGetters, mapState } from "vuex";
import { PermissionsActiveDialog } from "@/enums/permissions-active-dialog";
import PermissionsGrantedDialog from "@/components/Permissions/PermissionsGrantedDialog";
import FacilitiesDialog from "@/components/Permissions/FacilitiesDialog";
import SelectedCompany from "@/components/Permissions/SelectedCompany";
import PermissionsDialog from "@/components/Permissions/PermissionsDialog";
import { permissionsInfo } from "@/helpers/mixins/permissions-info";

export default {
  name: "Permissions",
  components: {
    CompanyMembersList,
    SelectedCompany,
    MemberDialog,
    PermissionsDialog,
    PermissionsGrantedDialog,
    FacilitiesDialog
  },
  mixins: [permissionsInfo],
  computed: {
    ...mapGetters({
      memberDialog: "permissions/memberDialog",
      facilitiesDialog: "permissions/facilitiesDialog",
      facilitiesGroupsDialog: "permissions/facilitiesGroupsDialog",
      permissionsDialog: "permissions/permissionsDialog",
      permissionsPreviewDialog: "permissions/permissionsPreviewDialog",
      permissionsGrantedDialog: "permissions/permissionsGrantedDialog",
      editMode: "permissions/editMode",
      previewMode: "permissions/previewMode"
    }),
    ...mapState({
      company: state => state.company.company
    })
  },
  data() {
    return {
      hasMembers: false,
      loading: false,
      dialogLoading: false
    };
  },
  created() {
    this.setCompany(this.$store.state.company.company);
  },
  methods: {
    addMember() {
      this.$store.commit("permissions/RESET_STORE");
      this.$store.dispatch("permissions/setActiveDialog", {
        type: PermissionsActiveDialog.MEMBERS
      });
    },
    setCompany(company) {
      this.$store.commit("permissions/SET_COMPANY", company);
    }
  }
};
</script>

<style lang="scss" scoped></style>
